<template>
  <div class="search-options">
    <div class="search-options-content">
      <div class="search-page-kind-view-icon">
        <ul>
          <li :class="{'active': search.kindList == 'list'}" @click="setKindList('list')"><view-list-icon title="Widok lista" /> </li>
          <li :class="{'active': search.kindList == 'gallery'}" @click="setKindList('gallery')"><view-module-icon title="Widok gallerii" /></li>
        </ul>
      </div>

      <div class="search-select">
        <b-form-select v-model="search.selectedSort" :options="optionsSort" class="mb-3" />
      </div>

      <div class="search-page-limit-select">
        <b-form-select v-model="search.page.limit" :options="optionsLimit" class="mb-3" />
      </div>

      <div class="search-available">
        <b-form-checkbox v-model="search.available" :value="true" :unchecked-value="false">
          Tylko dostępne
        </b-form-checkbox>
      </div>

      <div class="search-available">
        <b-form-checkbox v-model="outlet" :value="true" :unchecked-value="false">
          Outlet
        </b-form-checkbox>
      </div>

      <div class="search-page-pagination">
        <b-pagination align="right"  :total-rows="search.page.count" v-model="search.page.current" :per-page="search.page.limit" :limit="4">
        </b-pagination>
      </div>


      <div class="search-page-filters" v-if="search.phrase || search.categoryList.length >0 || search.producerList.length > 0 || search.attributes.length > 0">
        <div class="search-page-filters-title">Wybrane filtry</div>
        <div class="search-page-filters-content">


          <div v-if="search.phrase" class="filter" @click="removePhrase()">
            <span class="name">{{search.phrase}}</span>
            <span class="remove">x</span>
          </div>
          <div v-for="cat in search.categoryList" class="filter" @click="removeCategory(cat)">
            <span class="name">{{cat.name}}</span>
            <span class="remove">x</span>
          </div>
          <div v-for="brand in search.producerList" class="filter" @click="selectProducer(brand)">
            <span class="name" v-if="brands.list.find(b => b.id == brand).iphname"> {{ Cms.decode(brands.list.find(b => b.id == brand).iphname) }}</span>
            <span class="name" v-else=""> {{ Cms.decode(brands.list.find(b => b.id == brand).name) }}</span>
            <span class="remove">x</span>
          </div>

          <div v-for="attribute in search.attributes">
            <div v-for="value in attribute.values" class="filter" @click="selectFilter(attribute.name, value)">
              <span class="name">{{ Cms.decode(value) }}</span>
              <span class="remove">x</span>
            </div>
          </div>
        </div>

      </div>





    </div>
  </div>
</template>



<script>
  import { mapState } from 'vuex';
  import ViewListIcon from "vue-material-design-icons/ViewList.vue";
  import ViewModuleIcon from "vue-material-design-icons/ViewModule.vue";
  import  {BPagination, BFormSelect, BFormCheckbox} from '../BootstrapElements'
  import {Cms} from "../RedbayComponents"


  export default {
    components: {
      ViewModuleIcon,
      ViewListIcon,
      BPagination,
      BFormSelect,
      BFormCheckbox
    },
    computed: {
      ...mapState({
        search: state => state.search,
        brands: state => state.brands,
        limit: state => state.search.page.limit,
        sort: state => state.search.selectedSort,
        current: state => state.search.page.current,
        available: state => state.search.available,

      })
    },
    data() {
      return {
        optionsSort: [],
        optionsLimit: [],
        Cms: Cms,
        outlet: false
      }
    },
    watch: {
      limit: function(){
        this.$store.dispatch('search/reload');
      },
      sort: function(){
        this.$store.dispatch('search/reload');
      },
      current: function(){
        this.$store.dispatch('search/reload');
      },
      available: function(){
        this.$store.dispatch('search/reload');
      },
      outlet: function(){
        if (this.outlet) {
          if (this.search.groups.indexOf('Outlet') < 0) {
            this.search.groups.push('Outlet');
          }
        } else {
          if (this.search.groups.indexOf('Outlet') >= 0) {
            this.search.groups = this.search.groups.filter(g => g != 'Outlet');
          }
        }
        this.$store.dispatch('search/reload');
      },
    },

    methods: {
      setKindList(type) {
        this.$store.dispatch('search/setKindList', type);
      },
      selectProducer(id) {
        let index = this.search.producerList.indexOf(id);
        if (index > -1) {
          this.search.producerList.splice(index, 1);
        } else {
          this.search.producerList.push(id);
        }
        this.$store.dispatch('search/selectedProducer', this.search.producerList);
        this.$router.replace({ name: 'searchPage'});
      },

      selectFilter(name, value ) {
        let attribute = this.search.attributes.find(a => a.name == name);
        if (!attribute) {
          attribute = {name: name, values: []}
          this.search.attributes.push(attribute);
        }
        let index = attribute.values.indexOf(value);
        if (index > -1) {
          attribute.values.splice(index, 1);
        } else {
          attribute.values.push(value);
        }
        this.$store.dispatch('search/reload');
      },


      removeCategory(category) {
        let index = this.search.categoryList.indexOf(category);
        if (index > -1) {
          this.search.categoryList.splice(index, 1);
        }
        this.search.reload++;
      },

      removePhrase() {
        this.search.phrase = '';
        this.$store.dispatch('search/findByPhrase');
      }


    },


    async beforeMount() {
      this.optionsLimit = this.$config.get('searchPage.optionsLimit');
      this.optionsSort = this.$config.get('searchPage.optionsSort');
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/template/SearchOptions.vue